export const oktaAuthConfig = {
  // Note: If your app is configured to use the Implicit Flow
  // instead of the Authorization Code with Proof of Code Key Exchange (PKCE)
  // you will need to add `pkce: false`
  issuer: `https://${process.env.OKTA_DOMAIN ||
    "dev-84923031.okta.com"}/oauth2/default`,
  clientId: process.env.OKTA_CLIENT_ID || "0oacnh30sSjHqsIXC5d6",
  redirectUri: window.location.origin + "/okta-callback"
};

export const oktaSignInConfig = {
  baseUrl: `https://${process.env.OKTA_DOMAIN || "dev-84923031.okta.com"}`,
  clientId: process.env.OKTA_CLIENT_ID || "0oacnh30sSjHqsIXC5d6",
  redirectUri: window.location.origin + "/okta-callback",
  authParams: {
    // If your app is configured to use the Implicit Flow
    // instead of the Authorization Code with Proof of Code Key Exchange (PKCE)
    // you will need to uncomment the below line
    // pkce: false
  }
};

export const getOktaAuthConfig = () => {
  try {
    let result = localStorage.getItem("userLoginMethodDetails");
    if (result && result.length) {
      result = JSON.parse(result);
    } else {
      result = null;
    }
    if (result && result["client_id"]) {
      return {
        issuer: result["issuer"],
        clientId: result["client_id"],
        redirectUri: window.location.origin + "/okta-callback"
      };
    }
  } catch (e) {
    console.log({ getOktaAuthConfig_error: e });
  }
  return {
    issuer: ``,
    clientId: "",
    redirectUri: window.location.origin + "/okta-callback"
  };
  return {
    issuer: `https://${process.env.OKTA_DOMAIN ||
      "dev-84923031.okta.com"}/oauth2/default`,
    clientId: process.env.OKTA_CLIENT_ID || "0oacnh30sSjHqsIXC5d6",
    redirectUri: window.location.origin + "/okta-callback"
  };
};

export const getOktaSignInConfig = () => {
  try {
    let result = localStorage.getItem("userLoginMethodDetails");
    if (result && result.length) {
      result = JSON.parse(result);
    } else {
      result = null;
    }
    if (result && result["client_id"]) {
      return {
        baseUrl: `https://${result["domain"]}`,
        clientId: result["client_id"],
        redirectUri: window.location.origin + "/okta-callback",
        authParams: {
          // If your app is configured to use the Implicit Flow
          // instead of the Authorization Code with Proof of Code Key Exchange (PKCE)
          // you will need to uncomment the below line
          // pkce: false
        }
      };
    }
  } catch (e) {
    console.log({ getOktaSignInConfig_error: e });
  }
  return {
    baseUrl: ``,
    clientId: "",
    redirectUri: window.location.origin + "/okta-callback",
    authParams: {}
  };
  return {
    baseUrl: `https://${process.env.OKTA_DOMAIN || "dev-84923031.okta.com"}`,
    clientId: process.env.OKTA_CLIENT_ID || "0oacnh30sSjHqsIXC5d6",
    redirectUri: window.location.origin + "/okta-callback",
    authParams: {}
  };
};
